import { render, staticRenderFns } from "./LoadingPage.vue?vue&type=template&id=6366fac4&scoped=true&"
import script from "./LoadingPage.vue?vue&type=script&lang=ts&"
export * from "./LoadingPage.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingPage.vue?vue&type=style&index=0&id=6366fac4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6366fac4",
  null
  
)

export default component.exports